import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Col, Form } from 'react-bootstrap';
import { TextField } from '@components/Form/TextField';
import { RadioGroup } from '@components/Form/RadioGroup';

export const BusinessInformationExtra = () => {
  const { t } = useTranslation('register');

  return (
    <>
      <Form.Group>
        <Form.Row>
          <Form.Group as={Col} xs={12}>
            <h2>{t('title.extra-information')}</h2>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} xs={12}>
            <RadioGroup
              name="sex"
              options={[
                {
                  label: 'Dhr.',
                  value: 'male'
                },
                {
                  label: 'Mevr.',
                  value: 'female'
                }
              ]}
              custom
              inline
            />
          </Form.Group>
        </Form.Row>
      </Form.Group>

      <Form.Group>
        <Form.Row>
          <Form.Group as={Col} xs={12} md={6}>
            <TextField label={t('label.first-name')} type="text" name="firstName" />
          </Form.Group>
          <Form.Group as={Col} xs={12} md={6}>
            <TextField label={t('label.last-name')} type="text" name="lastName" />
          </Form.Group>
        </Form.Row>
      </Form.Group>

      <Form.Group>
        <Form.Row>
          <Form.Group as={Col} xs={12} md={6}>
            <TextField label={t('label.email-address')} type="text" name="emailAddress" />
          </Form.Group>
          <Col xs={12} md={6}>
            <TextField label={t('label.phone-number')} type="text" name="phoneNumber" />
          </Col>
        </Form.Row>
      </Form.Group>
    </>
  );
};
